class HistoryData {
    constructor() {
        this.m_id = Math.round(Math.random()*1000000);;
        this.m_undoData = null;
        this.m_redoData = null;
        this.m_dataFunction = null;
    }
}

export { HistoryData };